export default __webpack_public_path__ + "static/media/course_bg.87b1de7f.png";